module.exports = __webpack_public_path__ + "img/default_courseimg.4abdb290.svg";